module.exports = __webpack_public_path__ + "static/media/dixietogobg3.a62989b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dixietogobg3.png
// module id = 23
// module chunks = 0